module.exports = __webpack_public_path__ + "c40f21686060f16b90ffffe52a9c8caf.fbx";